export const tickerItems = [
  { text: "今日新增资源包 128 份", type: "更新" },
  { text: "网盘专区提取码批量修复完成，失效链接已重新上传", type: "修复" },
  { text: "夏季版设计素材资源包上线，含 1200+ 源文件", type: "上新" },
  { text: "本周话题墙投票开启：你最想要的资源类型", type: "话题" },
  { text: "办公文档模板合计 860MB，一键转存提醒", type: "提醒" },
];

export const channelNav = [
  { label: "首页", icon: "ri-home-5-line", active: true },
  { label: "爆料速递", icon: "ri-flashlight-line", active: false },
  { label: "资源包", icon: "ri-archive-2-line", active: false },
  { label: "网盘专区", icon: "ri-cloud-line", active: false },
  { label: "素材合集", icon: "ri-image-2-line", active: false },
  { label: "话题墙", icon: "ri-hashtag", active: false },
  { label: "更新日志", icon: "ri-history-line", active: false },
];

export const heroStats = [
  { value: "3,240", unit: "份", label: "资源包总量" },
  { value: "128", unit: "份", label: "今日更新" },
  { value: "18.6", unit: "万", label: "在库文件" },
  { value: "99.2", unit: "%", label: "链接有效率" },
];

export const heroTags = [
  "资源包合集",
  "网盘转存",
  "设计素材",
  "剪辑模板",
  "办公文档",
  "吃瓜资料",
  "壁纸图库",
  "学习笔记",
];

export const heroEntries = [
  {
    icon: "ri-archive-2-fill",
    title: "全量资源包合集",
    desc: "3,240 份 · 按周更新",
    action: "下载入口",
  },
  {
    icon: "ri-cloud-fill",
    title: "网盘文件专区",
    desc: "百度 / 夸克 / 阿里",
    action: "进入专区",
  },
  {
    icon: "ri-hashtag",
    title: "热门话题墙",
    desc: "实时热度排行",
    action: "查看话题",
  },
];

export const feedItems = [
  {
    id: "f1",
    tag: "资源包",
    tagClass: "bg-primary-100 text-primary-700",
    title: "本周精选：设计师常用素材资源包合集已更新至第 12 期",
    source: "爆瓜福利编辑部",
    time: "12 分钟前",
    heat: "8.9 万",
    thumb: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20stacked%20resource%20archive%20boxes%20with%20a%20download%20arrow%2C%20warm%20crimson%20and%20cream%20color%20scheme%2C%20minimal%20editorial%20icon%20style%2C%20soft%20clean%20cream%20background%20with%20subtle%20grain%20texture%2C%20centered%20balanced%20composition&width=300&height=300&seq=baogua-feed-01&orientation=squarish",
  },
  {
    id: "f2",
    tag: "网盘",
    tagClass: "bg-secondary-100 text-secondary-800",
    title: "夸克网盘大文件转存技巧整理，提取码失效也能快速找回",
    source: "网盘观察",
    time: "19 分钟前",
    heat: "6.2 万",
    thumb: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20cloud%20storage%20folder%20with%20sync%20arrows%2C%20warm%20amber%20and%20cream%20palette%2C%20minimal%20editorial%20icon%20style%2C%20soft%20clean%20cream%20background%20with%20subtle%20grain%20texture%2C%20centered%20balanced%20composition&width=300&height=300&seq=baogua-feed-02&orientation=squarish",
  },
  {
    id: "f3",
    tag: "素材",
    tagClass: "bg-accent-100 text-accent-900",
    title: "短视频剪辑模板 300 套打包放送，含转场、字幕与音效文件",
    source: "素材搬运工",
    time: "34 分钟前",
    heat: "5.7 万",
    thumb: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20video%20editing%20timeline%20with%20a%20play%20button%2C%20warm%20red%20and%20cream%20palette%2C%20minimal%20editorial%20icon%20style%2C%20soft%20clean%20cream%20background%20with%20subtle%20grain%20texture%2C%20centered%20balanced%20composition&width=300&height=300&seq=baogua-feed-03&orientation=squarish",
  },
  {
    id: "f4",
    tag: "爆料",
    tagClass: "bg-primary-100 text-primary-700",
    title: "网传某平台资源包更新规则调整，官方回应称将分批次放送",
    source: "吃瓜前线",
    time: "1 小时前",
    heat: "4.8 万",
    thumb: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20megaphone%20with%20speech%20bubbles%2C%20warm%20crimson%20and%20amber%20palette%2C%20minimal%20editorial%20icon%20style%2C%20soft%20clean%20cream%20background%20with%20subtle%20grain%20texture%2C%20centered%20balanced%20composition&width=300&height=300&seq=baogua-feed-04&orientation=squarish",
  },
  {
    id: "f5",
    tag: "合集",
    tagClass: "bg-secondary-100 text-secondary-800",
    title: "办公文档模板合集上新：简历、PPT、表格一次打包下载",
    source: "效率工具箱",
    time: "2 小时前",
    heat: "3.9 万",
    thumb: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20office%20documents%20and%20spreadsheet%20sheets%20stacked%20together%2C%20warm%20amber%20and%20cream%20palette%2C%20minimal%20editorial%20icon%20style%2C%20soft%20clean%20cream%20background%20with%20subtle%20grain%20texture%2C%20centered%20balanced%20composition&width=300&height=300&seq=baogua-feed-05&orientation=squarish",
  },
  {
    id: "f6",
    tag: "话题",
    tagClass: "bg-accent-100 text-accent-900",
    title: "本周话题墙投票：你最想要的资源包类型是哪一种？",
    source: "话题运营组",
    time: "3 小时前",
    heat: "3.1 万",
    thumb: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20question%20mark%20inside%20a%20voting%20ballot%20box%2C%20warm%20red%20and%20cream%20palette%2C%20minimal%20editorial%20icon%20style%2C%20soft%20clean%20cream%20background%20with%20subtle%20grain%20texture%2C%20centered%20balanced%20composition&width=300&height=300&seq=baogua-feed-06&orientation=squarish",
  },
];

export const hotRanking = [
  { rank: 1, title: "夏季版设计素材资源包", heat: "12.4 万" },
  { rank: 2, title: "短视频剪辑模板 300 套", heat: "9.8 万" },
  { rank: 3, title: "办公文档模板大礼包", heat: "8.6 万" },
  { rank: 4, title: "高清壁纸与插画图库", heat: "7.2 万" },
  { rank: 5, title: "学习资料网盘文件夹", heat: "6.4 万" },
  { rank: 6, title: "音乐音效免版权素材库", heat: "5.1 万" },
  { rank: 7, title: "电商详情页模板合集", heat: "4.3 万" },
];

export const quickChannels = [
  { label: "资源包下载", icon: "ri-download-2-line", color: "text-primary-600 bg-primary-100" },
  { label: "网盘文件", icon: "ri-cloud-line", color: "text-secondary-700 bg-secondary-100" },
  { label: "素材合集", icon: "ri-image-2-line", color: "text-accent-800 bg-accent-100" },
  { label: "话题墙", icon: "ri-hashtag", color: "text-primary-600 bg-primary-100" },
  { label: "更新日志", icon: "ri-history-line", color: "text-secondary-700 bg-secondary-100" },
  { label: "投稿入口", icon: "ri-send-plane-line", color: "text-accent-800 bg-accent-100" },
];

export const downloadPackages = [
  {
    id: "p1",
    name: "设计素材资源包 · 2026 夏季版",
    desc: "含 1200+ PSD / AI 源文件与配色方案",
    size: "2.4 GB",
    format: "PSD · AI",
    badge: "本周精选",
    badgeClass: "bg-primary-500 text-background-50",
    downloads: "4.6 万次",
    cover: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20design%20materials%20bundle%20with%20PSD%20layers%20and%20color%20swatches%2C%20warm%20crimson%20and%20amber%20tones%2C%20minimal%20editorial%20poster%20style%2C%20clean%20cream%20background%20with%20soft%20grain%20texture%2C%20balanced%20composition&width=640&height=400&seq=baogua-pack-01&orientation=landscape",
  },
  {
    id: "p2",
    name: "短视频剪辑模板合集",
    desc: "300 套转场 / 字幕 / 片头，兼容主流剪辑软件",
    size: "1.8 GB",
    format: "PR · 剪映",
    badge: "下载榜 TOP2",
    badgeClass: "bg-secondary-600 text-background-50",
    downloads: "3.9 万次",
    cover: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20video%20editing%20templates%20with%20film%20strip%20and%20subtitle%20bars%2C%20warm%20red%20and%20cream%20tones%2C%20minimal%20editorial%20poster%20style%2C%20clean%20cream%20background%20with%20soft%20grain%20texture%2C%20balanced%20composition&width=640&height=400&seq=baogua-pack-02&orientation=landscape",
  },
  {
    id: "p3",
    name: "办公文档模板大礼包",
    desc: "简历、PPT、表格模板一次打包，直接可用",
    size: "860 MB",
    format: "DOC · PPT",
    badge: "高频下载",
    badgeClass: "bg-accent-500 text-foreground-950",
    downloads: "3.4 万次",
    cover: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20office%20document%20templates%20with%20a%20resume%20sheet%20and%20charts%2C%20warm%20amber%20and%20cream%20tones%2C%20minimal%20editorial%20poster%20style%2C%20clean%20cream%20background%20with%20soft%20grain%20texture%2C%20balanced%20composition&width=640&height=400&seq=baogua-pack-03&orientation=landscape",
  },
  {
    id: "p4",
    name: "高清壁纸与插画图库",
    desc: "4000+ 张 4K 壁纸，手机与桌面双尺寸",
    size: "3.1 GB",
    format: "JPG · PNG",
    badge: "图文优选",
    badgeClass: "bg-primary-100 text-primary-700",
    downloads: "2.8 万次",
    cover: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20wallpaper%20gallery%20with%20abstract%20art%20frames%2C%20warm%20crimson%20and%20amber%20tones%2C%20minimal%20editorial%20poster%20style%2C%20clean%20cream%20background%20with%20soft%20grain%20texture%2C%20balanced%20composition&width=640&height=400&seq=baogua-pack-04&orientation=landscape",
  },
  {
    id: "p5",
    name: "学习资料网盘文件夹",
    desc: "考证 / 考研 / 语言笔记整理成册，含目录索引",
    size: "5.6 GB",
    format: "PDF · EPUB",
    badge: "持续更新",
    badgeClass: "bg-secondary-100 text-secondary-800",
    downloads: "2.2 万次",
    cover: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20study%20notes%20and%20open%20books%20with%20bookmarks%2C%20warm%20red%20and%20cream%20tones%2C%20minimal%20editorial%20poster%20style%2C%20clean%20cream%20background%20with%20soft%20grain%20texture%2C%20balanced%20composition&width=640&height=400&seq=baogua-pack-05&orientation=landscape",
  },
  {
    id: "p6",
    name: "音乐音效素材库",
    desc: "免版权 BGM 与音效 600+ 条，可商用",
    size: "1.2 GB",
    format: "WAV · MP3",
    badge: "免版权",
    badgeClass: "bg-accent-100 text-accent-900",
    downloads: "1.9 万次",
    cover: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20music%20waveform%20and%20audio%20equalizer%20bars%2C%20warm%20amber%20and%20cream%20tones%2C%20minimal%20editorial%20poster%20style%2C%20clean%20cream%20background%20with%20soft%20grain%20texture%2C%20balanced%20composition&width=640&height=400&seq=baogua-pack-06&orientation=landscape",
  },
];

export const topicTags = [
  { name: "资源包合集", count: "3,240 份", size: "lg", tone: "primary" },
  { name: "网盘转存技巧", count: "860 条", size: "md", tone: "secondary" },
  { name: "设计素材", count: "1,420 份", size: "lg", tone: "accent" },
  { name: "剪辑模板", count: "640 套", size: "md", tone: "primary" },
  { name: "办公文档", count: "980 份", size: "md", tone: "secondary" },
  { name: "吃瓜资料", count: "2,180 条", size: "lg", tone: "primary" },
  { name: "壁纸图库", count: "4,000+ 张", size: "md", tone: "accent" },
  { name: "学习笔记", count: "760 份", size: "sm", tone: "secondary" },
  { name: "音频素材", count: "600+ 条", size: "sm", tone: "accent" },
  { name: "字体合集", count: "120 款", size: "sm", tone: "primary" },
  { name: "投稿交流", count: "320 帖", size: "sm", tone: "secondary" },
  { name: "失效反馈", count: "48 条", size: "sm", tone: "accent" },
];

export const collections = [
  {
    id: "c1",
    name: "海报设计素材",
    count: "2,340 份",
    category: "设计",
    cover: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20poster%20design%20grids%20and%20layout%20guides%2C%20warm%20crimson%20and%20cream%20tones%2C%20minimal%20editorial%20style%2C%20clean%20cream%20background%20with%20soft%20grain%20texture%2C%20balanced%20composition&width=640&height=400&seq=baogua-col-01&orientation=landscape",
  },
  {
    id: "c2",
    name: "短视频片头模板",
    count: "860 套",
    category: "剪辑",
    cover: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20video%20intro%20template%20frames%20with%20motion%20lines%2C%20warm%20amber%20and%20cream%20tones%2C%20minimal%20editorial%20style%2C%20clean%20cream%20background%20with%20soft%20grain%20texture%2C%20balanced%20composition&width=640&height=400&seq=baogua-col-02&orientation=landscape",
  },
  {
    id: "c3",
    name: "商用无版权字体",
    count: "120 款",
    category: "字体",
    cover: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20typography%20letterforms%20and%20font%20specimen%20cards%2C%20warm%20red%20and%20cream%20tones%2C%20minimal%20editorial%20style%2C%20clean%20cream%20background%20with%20soft%20grain%20texture%2C%20balanced%20composition&width=640&height=400&seq=baogua-col-03&orientation=landscape",
  },
  {
    id: "c4",
    name: "电商详情页模板",
    count: "540 套",
    category: "电商",
    cover: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20an%20e-commerce%20product%20detail%20page%20mockup%2C%20warm%20crimson%20and%20amber%20tones%2C%20minimal%20editorial%20style%2C%20clean%20cream%20background%20with%20soft%20grain%20texture%2C%20balanced%20composition&width=640&height=400&seq=baogua-col-04&orientation=landscape",
  },
  {
    id: "c5",
    name: "播客配音音效",
    count: "1,120 条",
    category: "音频",
    cover: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20podcast%20microphone%20and%20audio%20sound%20waves%2C%20warm%20red%20and%20cream%20tones%2C%20minimal%20editorial%20style%2C%20clean%20cream%20background%20with%20soft%20grain%20texture%2C%20balanced%20composition&width=640&height=400&seq=baogua-col-05&orientation=landscape",
  },
  {
    id: "c6",
    name: "数据可视化图表",
    count: "380 套",
    category: "图表",
    cover: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20data%20charts%20with%20pie%20and%20bar%20graphs%2C%20warm%20amber%20and%20cream%20tones%2C%20minimal%20editorial%20style%2C%20clean%20cream%20background%20with%20soft%20grain%20texture%2C%20balanced%20composition&width=640&height=400&seq=baogua-col-06&orientation=landscape",
  },
];

export const netdiskFiles = [
  { id: "n1", name: "2026 夏季设计素材资源包.rar", platform: "夸克网盘", platformClass: "bg-secondary-100 text-secondary-800", size: "2.4 GB", code: "bg26", time: "今天 09:12" },
  { id: "n2", name: "短视频模板合集_300套.zip", platform: "百度网盘", platformClass: "bg-primary-100 text-primary-700", size: "1.8 GB", code: "sp30", time: "今天 08:40" },
  { id: "n3", name: "办公文档模板大礼包.zip", platform: "阿里云盘", platformClass: "bg-accent-100 text-accent-900", size: "860 MB", code: "of88", time: "昨天 22:15" },
  { id: "n4", name: "4K壁纸插画图库第7卷.rar", platform: "迅雷云盘", platformClass: "bg-secondary-100 text-secondary-800", size: "3.1 GB", code: "wp07", time: "昨天 19:02" },
  { id: "n5", name: "考证考研笔记整理合集.pdf", platform: "夸克网盘", platformClass: "bg-secondary-100 text-secondary-800", size: "5.6 GB", code: "st56", time: "前天 21:30" },
  { id: "n6", name: "免版权BGM音效库.rar", platform: "百度网盘", platformClass: "bg-primary-100 text-primary-700", size: "1.2 GB", code: "bg12", time: "前天 11:48" },
];

export const comments = [
  { id: "m1", user: "瓜田里的猹", level: "LV.8", avatarTone: "bg-primary-500", content: "夏季版素材包真的顶，源文件分层命名很清楚，改稿省了一半时间。", likes: 328, time: "8 分钟前" },
  { id: "m2", user: "剪辑小狗", level: "LV.6", avatarTone: "bg-secondary-600", content: "模板合集里的转场直接拖就能用，剪映和 PR 版本都给了，良心。", likes: 256, time: "26 分钟前" },
  { id: "m3", user: "效率工具控", level: "LV.9", avatarTone: "bg-accent-600", content: "办公文档那一包建议先看目录索引，找起来会快很多，别一通乱翻。", likes: 212, time: "1 小时前" },
  { id: "m4", user: "网盘老司机", level: "LV.7", avatarTone: "bg-primary-600", content: "夸克的分流链接速度最稳，失效了记得去话题墙反馈，补档很快。", likes: 187, time: "2 小时前" },
  { id: "m5", user: "设计阿凉", level: "LV.5", avatarTone: "bg-secondary-500", content: "字体合集终于有商用授权说明了，做甲方项目再也不用提心吊胆。", likes: 164, time: "3 小时前" },
  { id: "m6", user: "吃瓜不吐皮", level: "LV.4", avatarTone: "bg-accent-700", content: "话题墙投票投了壁纸图库，希望多来点竖屏手机尺寸的。", likes: 121, time: "4 小时前" },
];

export const updateLog = [
  { date: "09-10", title: "资源包专区新增夏季版设计素材", tag: "上新" },
  { date: "09-09", title: "网盘专区批量修复失效提取码", tag: "修复" },
  { date: "09-08", title: "话题墙上线本周投票功能", tag: "功能" },
  { date: "09-07", title: "音乐音效库补充 120 条免版权素材", tag: "补充" },
  { date: "09-06", title: "模板合集页面支持格式筛选", tag: "优化" },
];

export const footerColumns = [
  { title: "资源导航", links: ["资源包下载", "网盘文件专区", "素材内容合集", "话题标签墙"] },
  { title: "热门内容", links: ["设计素材资源包", "短视频剪辑模板", "办公文档模板", "高清壁纸图库"] },
  { title: "站务支持", links: ["更新日志", "失效反馈", "投稿入口", "使用说明"] },
  { title: "关于站点", links: ["站点介绍", "免责声明", "联系邮箱", "友情链接"] },
];